/* eslint-disable no-restricted-globals */
import { removePromo } from '../../apis/shop.service';
import { ERROR_PROMO_REACHED_LIMIT, ERROR_UPDATE_PROMO, PROMOTYPES } from '../../constants';
import { checkAccess } from '../../utils/admins';
import _ from 'lodash';
export const handleClick = (setStateObj, createPromo = false, e = {}) => {
  const { type = '' } = e;
  const promotionType = isNaN(type)
    ? type.indexOf('%') !== -1
      ? PROMOTYPES.percentage
      : PROMOTYPES.freeDelivery
    : type > 0
      ? PROMOTYPES.euro
      : '';
  const value = isNaN(type) ? type.split('%')[0] : type;
  setStateObj({ modalOpen: true, createPromo, promo: { ...e, promotionType, value } });
};

export const handleClose = setStateObj => {
  setStateObj({ modalOpen: false });
};
export const closeModal = setStateObj => {
  setStateObj({ modalOpen: false });
};
export const handleRemovePromo = async (key, promotions, activation, setStateObj, openErrorModal) => {
  try {
    await removePromo(key, activation, promotions);
  } catch (error) {
    openErrorModal(ERROR_UPDATE_PROMO);
  }
  setStateObj({ promoToActive: false });
};
export const handleRemove = (removePromo, promotions, activation, setStateObj, showModal, openErrorModal) => {
  const { limit, nbAdded, isGeneralData, promoCode, key } = removePromo;
  if ((isGeneralData && checkAccess('features', 'modifyGlobalPromo')) || !isGeneralData) {
    if (nbAdded < limit || activation === false || limit === undefined) {
      const modalData = {
        color: `${activation ? 'primary' : 'danger'}`,
        title: `Êtes-vous sûr(e) de vouloir ${activation ? 'activer' : 'désactiver'
          } le code promotionnel ${promoCode} ?`,
        showCancelBtn: true,
        btnColor: `${activation ? 'primary' : 'danger'}`,
        onClick: () => {
          handleRemovePromo(key, promotions, activation, setStateObj, openErrorModal);
          showModal(null);
        },
        btnTxt: `${activation ? 'Activer' : 'Désactiver'}`
      };
      showModal(modalData);
    } else {
      openErrorModal(ERROR_PROMO_REACHED_LIMIT);
    }
  } else {
    openErrorModal(ERROR_UPDATE_PROMO);
  }
};
export const getAllShopsPromotions = (shops) => {
  let generalPromotions = {};
  _.forEach(Object.keys(shops), shopId => {
    const shop = shops[shopId]
    _.forEach(shop?.promotions, (promotion, promoCode) => {
      if (promotion.isGeneralData) {
        if (generalPromotions[promoCode]) {
          generalPromotions[promoCode].nbUsed += promotion.nbUsed || 0;
          generalPromotions[promoCode].shopIds = [...generalPromotions[promoCode].shopIds, shopId]
        } else {
          generalPromotions[promoCode] = {
            ...promotion,
            shopIds: [shopId],
            nbUsed: promotion.nbUsed || 0
          };
        }
      }
    });
  });
  return generalPromotions;
};

